module.exports = __webpack_public_path__ + "src/img/locate.15c1b9ed.svg";